(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-finder-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(root) {
    if (root.dataset.pfqBound) return;
    root.dataset.pfqBound = '1';

    var selected = { '1': [], '2': [] }; // each step holds a list of chosen tags (multi-select)
    var grid = root.querySelector('[data-grid]');
    var hint = root.querySelector('[data-hint]');
    var empty = root.querySelector('[data-empty]');
    var moreBtn = root.querySelector('[data-more]');
    var countEl = root.querySelector('[data-count]');
    var panel3 = root.querySelector('[data-panel="3"]');
    var title3 = panel3 ? panel3.querySelector('.pfq__question') : null;
    var perPage = parseInt(grid && grid.getAttribute('data-per-page'), 10) || 12;
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.pfq__card')) : [];
    var matched = [], shown = 0;

    cards.forEach(function (card) {
      try { card._tags = JSON.parse(card.getAttribute('data-tags') || '[]'); }
      catch (e) { card._tags = []; }
    });

    root.querySelectorAll('.pfq__options').forEach(function (group) {
      var g = group.getAttribute('data-group');
      group.querySelectorAll('.pfq__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tag = btn.getAttribute('data-tag') || '';
          var arr = selected[g];
          var already = arr.indexOf(tag) !== -1;
          // Single-select per question: clear this group's current choice and
          // deselect every option in the group first.
          arr.length = 0;
          group.querySelectorAll('.pfq__option').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          // Select the clicked one; clicking the already-active option clears it (toggle off).
          if (!already) {
            arr.push(tag);
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          }
          updateSteps();
          filter();
        });
      });
    });

    if (moreBtn) moreBtn.addEventListener('click', reveal);

    function updateSteps() {
      var s1 = selected['1'].length > 0;
      var s2 = selected['2'].length > 0;
      root.querySelectorAll('.pfq__step').forEach(function (step) {
        var n = step.getAttribute('data-stepnum');
        step.classList.remove('is-active', 'is-done');
        if (n === '1') { s1 ? step.classList.add('is-done') : step.classList.add('is-active'); }
        else if (n === '2') { s2 ? step.classList.add('is-done') : (s1 ? step.classList.add('is-active') : null); }
        else if (n === '3') { if (s1 && s2) step.classList.add('is-active'); }
      });
    }

    function stepMatches(card, tags) {
      // No selection in this step = no constraint.
      if (!tags.length) return true;
      // Within a step: AND — the product must have EVERY chosen tag.
      // A blank tag (e.g. "Not sure") is treated as "no preference".
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] !== '' && card._tags.indexOf(tags[i]) === -1) return false;
      }
      return true;
    }

    function filter() {
      var s1 = selected['1'], s2 = selected['2'];
      var anySelected = s1.length > 0 || s2.length > 0;
      cards.forEach(function (c) { c.hidden = true; });
      shown = 0;
      if (hint) hint.hidden = true;

      // Nothing selected → hide the whole "We recommend" section.
      if (!anySelected) {
        matched = [];
        if (panel3) panel3.hidden = true;
        if (title3) title3.hidden = false;
        if (empty) empty.hidden = true;
        if (moreBtn) moreBtn.hidden = true;
        if (countEl) countEl.hidden = true;
        return;
      }

      // Across steps: AND — the product must satisfy each answered step.
      matched = cards.filter(function (card) {
        return stepMatches(card, s1) && stepMatches(card, s2);
      });
      if (panel3) panel3.hidden = false; // section stays visible once a choice is made

      if (matched.length === 0) {
        // No match: hide the "We recommend" title + Load more, show the message.
        if (title3) title3.hidden = true;
        if (empty) empty.hidden = false;
        if (moreBtn) moreBtn.hidden = true;
        if (countEl) countEl.hidden = true;
        return;
      }

      // Has matches: show the title, hide the message, reveal products.
      if (title3) title3.hidden = false;
      if (empty) empty.hidden = true;
      reveal();
    }

    function reveal() {
      var next = matched.slice(shown, shown + perPage);
      next.forEach(function (c) { c.hidden = false; });
      shown += next.length;
      if (moreBtn) moreBtn.hidden = shown >= matched.length;
      if (countEl) {
        countEl.hidden = matched.length === 0;
        countEl.textContent = 'Showing ' + shown + ' of ' + matched.length;
      }
    }

    filter(); // show all candidates by default; answers narrow the list
  }

  function boot() { document.querySelectorAll('[data-pfq]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pfq]');
    if (el) initQuiz(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
